/*
 * Formato del código de tarjeta en la ficha del empleado (spec
 * docs/superpowers/specs/2026-09-25-kiosco-seguridad-design.md, decisiones 4 y 5).
 * - Los códigos aleatorios los genera el backend (POST /employee/card/generate/<id>/): 12 caracteres de
 *   CARD_CODE_ALPHABET (sin 0 O 1 I L). formatCardCode los agrupa de a 4 SOLO para el texto legible bajo
 *   el código de barras; las barras siguen codificando el valor sin espacios.
 * - Los códigos antiguos (3 letras + 4 números, p. ej. ALE0001) siguen válidos pero se adivinan fácil:
 *   isLegacyCardCode permite sugerir regenerarlos. Un UID NFC vinculado a mano no es ninguno de los dos.
 */
export const CARD_CODE_ALPHABET = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
const GENERATED_PATTERN = new RegExp(`^[${CARD_CODE_ALPHABET}]{12}$`);
const LEGACY_PATTERN = /^[A-Z]{3}\d{4}$/;

/** true si es un código aleatorio del backend (12 caracteres del alfabeto). */
export function isGeneratedCardCode(code) {
    return typeof code === 'string' && GENERATED_PATTERN.test(code);
}

/** true si es un código antiguo prefijo + número (ALE0001). */
export function isLegacyCardCode(code) {
    return typeof code === 'string' && LEGACY_PATTERN.test(code);
}

/** 'ABCD EFGH 2345' para los códigos aleatorios; cualquier otro valor tal cual ('' si no hay). */
export function formatCardCode(code) {
    if (!code) return '';
    return isGeneratedCardCode(code) ? code.match(/.{4}/g).join(' ') : code;
}
